import React from 'react';
import ReactDOM from "react-dom";
import moment from 'moment';
import {connect} from "react-redux";
import Rdx from "../../../../../redux/Rdx";

// 3rd party
import Loader from "calcite-react/Loader";
import XIcon from "calcite-ui-icons-react/XIcon";
import PencilIcon from "calcite-ui-icons-react/PencilIcon";

// aiim.base
import ItemReference from '../../../../../aiim/base/ItemReference';

// aiim.datasets
import FieldNames from '../../../../../aiim/datasets/FieldNames';

// aiim.util
import { getAttributeValue } from '../../../../../aiim/util/aiimUtil';

// components.util
import * as component from '../../../../util/component';
import * as aiimUtil from "../../../../../aiim/util/aiimUtil";
import * as checkInOutUtil from "./CheckInOutUtil";
import * as validateUtil from './validateUtil';

// context
import Context from '../../../../../context/Context';
import Topic from '../../../../../context/Topic';
import SignInIcon from "calcite-ui-icons-react/SignInIcon";
import SignOutIcon from "calcite-ui-icons-react/SignOutIcon";
import ClockIcon from 'calcite-ui-icons-react/ClockIcon';
import PinIcon from 'calcite-ui-icons-react/PinIcon';
import Button from "calcite-react/Button";

import { ModalController }  from "../../../../../../src/common/components/Modal/index";
import { cancelBooking, updateCheckInOut } from "./WorkspaceReservation/OfficeHotelingInterface";
import * as workspaceReservationUtil from "./WorkspaceReservation/workspaceReservationUtil";

// util
import CalendarSelector from '../../../../../util/CalendarSelector';
import BookingCancel from './BookingCancel';
import BookingConfirmed from './BookingConfirmed';

import { stringFormatter } from '../../../../../util/formatUtil';
import { makeEventInfo } from '../../../../../util/calendarUtil';
import Icons from '../../../../util/Icons';
import { isNetworkError } from '../../../../../util/networkUtil';
import { getHotelBookingSystem, getHotelBookingSystemType } from './WorkspaceReservation/workspaceReservationUtil';

const CSS = {
  bookingCardList: "i-booking-card-list",
  bookingCard: "i-booking-card",
  locationDescription: "i-booking-location-description",
  button: "i-book-button",
  buttonCheckIn: "i-book-card-button-checkIn",
  buttonCheckOut: "i-book-card-button-checkOut",
  actionGroup: "i-action-group",
  actionSubGroup: "i-action-subgroup",
  addToCalendar: "i-booking-add-calendar",
  cancel: "i-booking-cancel",
  edit: "i-booking-edit",
  descriptionContent: "i-booking-description",
  bookingInfoLine: "i-booking-info-line"
};

const APPROVED = 1;
const CHECKED_IN = 4;

class MyBookings extends React.Component {

  listReminders = {
    checkIn: [],
    checkOut: []
  };
  remindersShown = {
    checkIn: false,
    checkOut: false
  };
  where;
  updateICSfile = false;

  constructor(props) {
    super(props);

    this.state = component.newState({
      bookings: [],
      isWorking: true
    });
  }

  async componentDidMount() {
    await this._getUserReservations();
    component.own(this, [
      Topic.subscribe(Topic.RenderBookingList, async() => {
        this.setState({isWorking: true})
        this.updateICSfile=true;
        await this._getUserReservations();
      })
    ])
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.bookingDateFilter !== this.props.bookingDateFilter) {
      this.setState({isWorking: true});
      this._getUserReservations();
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  _getUserReservations = async () => {
    checkInOutUtil.getUserReservations("mybookings", this.props.bookingDateFilter)
    .then((res)=> {
      this.setState({
        bookings : res && res.bookings,
        isWorking: res && res.isWorking
      })
    })
    .catch(error => {
      console.error(error);
    })
  }

  sortBookings = (bookings) => {
    return bookings.sort((resA, resB) => {
      const attrsA = resA.booking.attributes;
      const attrsB = resB.booking.attributes;

      const startTimeA = getAttributeValue(attrsA, FieldNames.START_TIME);
      const startTimeB = getAttributeValue(attrsB, FieldNames.START_TIME);

      if (startTimeA > startTimeB) {
        return 1;
      } else if (startTimeA < startTimeB) {
        return -1
      }
      return 0;
    });
  }

  /**
   * Filter out the checked in bookings that are past their grace period (11:59 PM the day after the end time)
   * 
   * @param {any[]} bookings 
   * @returns Filtered bookings
   */
  filterCheckedInBookings = (bookings) => {
    return bookings.filter((reservation) => {
      const attrs = reservation.booking.attributes;
      const state = getAttributeValue(attrs, FieldNames.STATE);
      const endTime = getAttributeValue(attrs, FieldNames.END_TIME);

      const now = moment();
      const mEndTime = moment(endTime);

      return state === CHECKED_IN ? now < mEndTime.endOf("day").add(1, "day") : true;
    });
  }

  getRemindersList = (sortedBookings) => {
    if (!sortedBookings) {
      return;
    }

    this.listReminders = {
      checkIn: [],
      checkOut: []
    };
    sortedBookings.forEach((data) => {
      // Get field values
      const attributes = data.booking.attributes;
      const startTime = getAttributeValue(attributes, FieldNames.START_TIME);
      const endTime = getAttributeValue(attributes, FieldNames.END_TIME);
      const state = getAttributeValue(attributes, FieldNames.STATE);

      // Comparisons
      const startTimeM = moment(startTime);
      const currentTime = moment();
      const elapsed = startTimeM.diff(currentTime, 'seconds');
      const needsCheckIn = (0 <= elapsed && elapsed <= 300) || (startTime <= currentTime && currentTime <= endTime);
      const needsCheckOut = currentTime.isAfter(moment(endTime));

      if (state === APPROVED && needsCheckIn) {
        this.listReminders.checkIn.push(attributes);
      } else if (state === CHECKED_IN && needsCheckOut) {
        this.listReminders.checkOut.push(attributes);
      }
    });
  }

  makeBookingList = (bookings) => {
    const reservations = Context.getInstance().aiim.datasets && Context.getInstance().aiim.datasets.reservations;
    if (!reservations) {
      return [];
    }

    const filteredBookings = this.filterCheckedInBookings(bookings);
    const sortedBookings = this.sortBookings(filteredBookings);
    this.listReminders = checkInOutUtil.getRemindersList(sortedBookings, "mybookings");

    
    if (this.listReminders && this.listReminders.checkIn && this.listReminders.checkIn.length > 0) {
      if (!this.remindersShown["checkIn"]) {
        checkInOutUtil.showReminderPopup("checkIn", this.listReminders, "mybookings");
        this.remindersShown["checkIn"] = true;
      }
    } else if (this.listReminders && this.listReminders.checkOut && this.listReminders.checkOut.length > 0) {
      if (!this.remindersShown["checkOut"]) {
        checkInOutUtil.showReminderPopup("checkOut", this.listReminders, "mybookings");
        this.remindersShown["checkOut"] = true;
      }
    }


    const myBookingsList = [];
    sortedBookings.forEach((data) => {
      const reservation = data.booking;
      const id = aiimUtil.getAttributeValue(reservation.attributes, reservations.getObjectIdField());
      const state = aiimUtil.getAttributeValue(reservation.attributes, FieldNames.STATE);
      const showButton = state === CHECKED_IN ? "checkOut" : state === APPROVED ? "checkIn" : undefined;
      if (state === APPROVED || state === CHECKED_IN) {
        myBookingsList.push(
          <MyBookingsCard 
            showButton={showButton} 
            key={id} 
            reservation={reservation}
            data={data} 
            updateICSfile={this.updateICSfile}
          />
        );
      }
    });

    return myBookingsList;
  }

  /**
   * Show a reminder popup to prompt the user to check in/out
   * 
   * @param {"checkIn" | "checkOut"} type 
   */
  showPopup = async (type) => {
    // Let's not keep showing these after the specific reminder has been shown once
    if (this.remindersShown[type]) {
      return;
    }
    this.remindersShown[type] = true;

    const i18n = Context.getInstance().i18n;
    const { listReminders } = this;
    const reminders = listReminders[type];

    const reminderUnitNames = reminders.map((reminder) => getAttributeValue(reminder, FieldNames.UNIT_NAME)).join(", ");
    const template = type === "checkIn" 
      ? i18n.more.bookWorkspace.checkInOut.reminder.newMessage 
      : i18n.more.bookWorkspace.checkInOut.checkOut.reminderMessageAlt;
    const message = stringFormatter(template, { units: reminderUnitNames, hotel: reminderUnitNames });

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.reminder.caption,
      okLabel: i18n.more.bookWorkspace.checkInOut.reminder.close,
      message: message,
      showOkCancel: true,
      hideCancel : true,
      closeOnOK: true
    };

    const refresh = () => {
      Topic.publish(Topic.RenderBookingList, {});
      Topic.publish(Topic.UpdateReservationDetails, {});
    }

    const showToast = () => {
      Topic.publish(Topic.ShowToast, {
        message: i18n.more.bookWorkspace.checkInOut[type].toastMessage
      });
    }

    if (reminders.length === 1) {
      const reservations = Context.instance.aiim.datasets && Context.instance.aiim.datasets.reservations;
      const bookingSystem = getHotelBookingSystem();
      const attributes = reminders[0];

      if (type === "checkIn") {
        attributes[reservations.checkInTimeField] = new Date().getTime();
      } else if (type === "checkOut") {
        attributes[reservations.checkOutTimeField] = new Date().getTime();
      }

      const unitName = attributes[reservations.unitNameField];
      const template = type === "checkIn" 
        ? i18n.more.bookWorkspace.checkInOut.checkIn.bookingReady
        : i18n.more.bookWorkspace.checkInOut.checkOut.reminderMessageAlt;
      const message = stringFormatter(template, { unit: unitName, hotel: unitName });

      options.message = message;
      options["okLabel"] = i18n.more.bookWorkspace[type];
      options["hideCancel"] = false;
      options["cancelLabel"] = i18n.more.bookWorkspace.checkInOut.notNow;

      try {
        if (!reservations.canUserEditFeature(attributes)) {
          const reservationManager = getAttributeValue(attributes, FieldNames.RESERVED_BY_FULL_NAME);
          checkInOutUtil.showNoEditPopup(type, reservationManager);
          return;
        }
        
        const result = await ModalController.confirm(options);
        if (result && result.ok) {
          const updateResponse = await updateCheckInOut(bookingSystem, attributes, type);
          if (
            updateResponse && 
            updateResponse.updateFeatureResults && 
            updateResponse.updateFeatureResults[0] && 
            updateResponse.updateFeatureResults[0].error
          ) {
            throw new Error(updateResponse.updateFeatureResults[0].error);
          } else {
            showToast();
            refresh();
          }
        }
      } catch (error) {
        console.error(error);
        Topic.publishErrorUpdatingData(error);
      } finally {
        if (type === "checkIn" && this.listReminders.checkOut.length > 0) {
          await this.showPopup("checkOut");
        }
      }
    } else {
      try {
        await ModalController.confirm(options);
      } catch (error) {
        console.error(error);
        Topic.publishErrorUpdatingData(error);
      } finally {
        if (type === "checkIn" && this.listReminders.checkOut.length > 0) {
          await this.showPopup("checkOut");
        }
      }
    }
  }

  renderBookingCards() {
    const i18n = Context.getInstance().i18n;
    const { bookings } = this.state;
    const bookingList = this.makeBookingList(bookings);

    return bookingList && bookingList.length > 0 ? (
      <ul className={CSS.bookingCardList}>
        {bookingList}
      </ul>
    ) : (
      <div style={{ padding: '0.7rem 1rem' }}>{i18n.more.bookWorkspace.noBookings}</div>
    );
  }

  renderWorking() {
    return (<Loader sizeRatio={1} style={{ marginTop: '3rem' }} />);
  }

  render() {
    const { isWorking } = this.state;
    return isWorking ? this.renderWorking() : this.renderBookingCards();
  }
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

class MyBookingsCard extends React.Component {
  _componentId;
  _itemRef;
  _accessToken;

  constructor(props) {
    super(props);
    this.state = component.newState({
      showButton: this.props.showButton,
      hideCheckIn: false,
      popoverOpen: false
    });
    this._componentId = component.nextId("booking-");
    this._itemRef = React.createRef();
  }

  componentDidMount() {
    // this._startupApp();
    this._init();
    component.own(this, [
      Topic.subscribe(Topic.InfoPanelClosed, params => {
        if (this._componentId === params.componentId) {
          this._focus();
        }
      })
   ]);
  }

  componentWillUnmount(){
    component.componentWillUnmount(this);
  }

  _init =async()=> {
    const unitAttr = this.props && this.props.data && this.props.data.unit && this.props.data.unit.attributes;
    const unitId = getAttributeValue(unitAttr, FieldNames.UNIT_ID);
    let unitFeature = await workspaceReservationUtil.queryUnitByUnitId(unitId);
    if (unitFeature && unitFeature.features && unitFeature.features.length > 0) {
      unitFeature = unitFeature.features[0];
      this.setState({
        unitFeature: unitFeature
      })
    }
  }

  _startupApp = () => {
    const { data } = this.props;
    const reservation = data.booking;
    const attributes = reservation.attributes;
    const state = aiimUtil.getAttributeValue(attributes, FieldNames.STATE);
    const hideCheckIn = checkInOutUtil.hideCheckInButton(attributes);

    if(state === CHECKED_IN) {
      this.setState({
        showButton : "checkOut",
        hideCheckIn: hideCheckIn
      })
    }else if(state === APPROVED) {
      this.setState({
        showButton : "checkIn",
        hideCheckIn: hideCheckIn
      })
    }
  }

  _focus() {
    if (this._itemRef && this._itemRef.current && this._itemRef.current.focus) {
      this._itemRef.current.focus()
    }
  }

  _bookingCardClicked = () => {
    const { data } = this.props;
    const unit = data.unit;
    const source = Context.instance.aiim.datasets.units.getSource();

    const item = new ItemReference();
    item.fromSearchResult(source.key, { feature: unit, name: source.getTitle(unit) });

    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: item.searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      componentId: this._componentId
    });
  }

  
  checkAvailability = async(checkInDate, checkOutDate, allDay, options)=> {
    const unitFeature = this.state.unitFeature;
    const info = {
      checkInDate:checkInDate,
      checkOutDate:checkOutDate,
      allDay:allDay,
      options:options,
      unitFeature: unitFeature,
      reservation: this.props && this.props.data && this.props.data.booking,
      unit: this.props && this.props.data && this.props.data.unit,
      bookingType: 'hotel',
      renderBookingConfirmed: this.renderBookingConfirmed
    }
    return workspaceReservationUtil.checkAvailability(info);
  }

  renderBookingConfirmed(data, params, task) {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    const origResAttr = task && task.reservation && task.reservation.attributes;

    ReactDOM.render((
      <BookingConfirmed
        bookingSystemType={getHotelBookingSystemType()}
        unitName={task.unitName}
        levelName={task.levelName}
        facilityName={task.facilityName}
        closePopup={onClose}
        data={data}
        unit={params && params.unit}
        updateBooking={task && task.updateBooking}
        origResAttr={origResAttr}
        params={params}
      />
    ), node);
  }
  renderCancelConfirmed(attributes) {
    const unitName = getAttributeValue(attributes, FieldNames.UNIT_NAME);
    
    const node = document.createElement("div");
    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    document.body.appendChild(node);
    ReactDOM.render(
      <BookingCancel
        bookingSystemType={getHotelBookingSystemType()}
        unitName={unitName}
        closePopup={onClose}
        data={this.props.data}        
      />, node);
  }
  handleToggle = () => {
    const i18n = Context.getInstance().i18n;
    const reservations = Context.getInstance().aiim.datasets 
                          && Context.getInstance().aiim.datasets.reservations;
    const { data } = this.props;
    const reservation = data.booking;
    const attributes = reservation.attributes;
    const reservationManager = getAttributeValue(attributes, FieldNames.RESERVED_BY_FULL_NAME);
  
    let objectIdField;
    if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
      objectIdField = reservations.layer2D.objectIdField
    }

    const bookingSystem = getHotelBookingSystem();
    if(this.props && this.props.showButton === "checkOut") {

      // check if user has edit permission on the reservation
      if (!reservations.canUserEditFeature(attributes)) {
        checkInOutUtil.showNoEditPopup("checkOut", reservationManager);
        return;
      }
      const options = {
        title: i18n.more.bookWorkspace.checkInOut.checkOut.caption,
        message: i18n.more.bookWorkspace.checkInOut.checkOut.message,
        okLabel: i18n.more.bookWorkspace.checkInOut.checkOut.yes,
        cancelLabel: i18n.more.bookWorkspace.checkInOut.checkOut.no,
        closeOnOK: true,
        closeOnCancel: true
      };
      ModalController.confirm(options)
      .then(result => {
        if(result.ok) {
          attributes[reservations.checkOutTimeField] = new Date().getTime();
          const objectID = getAttributeValue(attributes,objectIdField);

          updateCheckInOut(bookingSystem, attributes, "checkOut")
          .then((res)=> {
            if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
              res.updateFeatureResults[0].error){
                Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
              } else {
                Topic.publish(Topic.ShowToast,{
                  message: i18n.more.bookWorkspace.checkInOut.checkOut.toastMessage
                });
                Topic.publish(Topic.RenderBookingList, {});
                Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
              }
          })
          .catch(error => {
            if(error && isNetworkError(error.message)) {
              checkInOutUtil.showServerErrorPopup("checkOut", attributes);
            } else {
              Topic.publishErrorUpdatingData(error);
            }
            console.error(error);
          })
        }
      })
      .catch(error => {
        console.error(error);
        Topic.publishErrorUpdatingData(error)
      })
    }else if( this.props && this.props.showButton === "checkIn") {

      // check if user has edit permission on the reservation
      if (!reservations.canUserEditFeature(attributes)) {
        checkInOutUtil.showNoEditPopup("checkIn", reservationManager);
        return;
      }

      const unitName = attributes && aiimUtil.getAttributeValue(attributes, FieldNames.UNIT_NAME);
      const message = i18n.more.bookWorkspace.checkInOut.checkIn.newMessage.replace("{unit}", unitName);

      const options = {
        title: i18n.more.bookWorkspace.checkInOut.checkIn.caption,
        message: message,
        okLabel: i18n.more.bookWorkspace.checkInOut.checkIn.yes,
        cancelLabel: i18n.more.bookWorkspace.checkInOut.checkIn.no,
        closeOnOK: true,
        closeOnCancel: true
      };
      ModalController.confirm(options)
      .then(result => {
        if(result.ok) {
          attributes[reservations.checkInTimeField] = new Date().getTime();
          const objectID = getAttributeValue(attributes,objectIdField);
          updateCheckInOut(bookingSystem, attributes, "checkIn")
          .then((res)=> {
            if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
              res.updateFeatureResults[0].error){
                Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
              } else {
                Topic.publish(Topic.ShowToast,{
                  message: i18n.more.bookWorkspace.checkInOut.checkIn.toastMessage
                });
                Topic.publish(Topic.RenderBookingList, {});
                Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
              }
          })
          .catch(error => {
            if(error && isNetworkError(error.message)) {
              checkInOutUtil.showServerErrorPopup("checkIn", attributes);
            } else {
              Topic.publishErrorUpdatingData(error);
            }
            console.error(error);
          })
        }
      })
      .catch(error => {
        console.error(error);
        Topic.publishErrorUpdatingData(error)
      })
    }
  }

  _cancelClicked = () => {
    const { data } = this.props;
    const reservation = data.booking;
    const bookingSystem = getHotelBookingSystem();
    const attributes = reservation.attributes;
    const unitName = getAttributeValue(attributes, FieldNames.UNIT_NAME);
    const i18n = Context.getInstance().i18n;
    const reservations = Context.getInstance().aiim.datasets.reservations;
    const reservationManager = getAttributeValue(attributes, FieldNames.RESERVED_BY_FULL_NAME);

    // check if user has edit permission on the reservation
    if (!reservations.canUserEditFeature(attributes)) {
      checkInOutUtil.showNoEditPopup("cancel", reservationManager);
      return;
    }

    let objectIdField;
    if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
      objectIdField = reservations.layer2D.objectIdField
    }
    const objectID = getAttributeValue(attributes,objectIdField);
    let msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.message;
    if (unitName) {
      msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.newMessage;
      msg = msg.replace("{unit}",unitName);
    }

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.cancelBooking.modalTitle,
      message: msg,
      okLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.yes,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.no,
      showOKCancel: true,
      closeOnOK: true,
      closeOnCancel: true
    };
    ModalController.confirm(options)
    .then(result => {
      if(result && result.ok) {
        cancelBooking(bookingSystem, attributes)
        .then((res) => {
          if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
            res.updateFeatureResults[0].error){
              Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
            } else {
              this.renderCancelConfirmed(attributes);
              Topic.publish(Topic.RenderBookingList, {});
              Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
            }
          })
        .catch(error => {
          if(error && error.message === "Failed to fetch") {
            checkInOutUtil.showServerErrorPopup("cancel", attributes);
          } else {
            Topic.publishErrorUpdatingData(error);
          }
          console.error(error);
          if (error && isNetworkError(error.message)) {
            const i18n = Context.getInstance().i18n;
            const template = i18n.meetingRooms.issues.m9;
            const message = stringFormatter(template, { unit: unitName });
            Topic.publishNetworkError(message)
          } else {
            Topic.publishErrorUpdatingData();
          }
        })
      }
    })
    .catch(error => {
      console.error(error);
      Topic.publishErrorUpdatingData(error)
    })
  }

  _onKeyDown = (event) => {
    const ENTER = 13;
    const SPACE = 32;

    if (event.keyCode === ENTER || event.keyCode === SPACE) {
      event.preventDefault();
      this._bookingCardClicked();
    }
  }

  _togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const { data, showButton } = this.props;
    const reservation = data.booking;
    const unit = data.unit;
    const { popoverOpen } = this.state;
    const reservations = Context.getInstance().aiim.datasets.reservations;
    const levels = Context.getInstance().aiim.datasets.levels;
    const attributes = reservation.attributes;
    const floorField = reservations.levelIdField;

    // Field values to display
    const startTime = getAttributeValue(attributes, FieldNames.START_TIME);
    const endTime = getAttributeValue(attributes, FieldNames.END_TIME);
    const unitName = getAttributeValue(attributes, FieldNames.UNIT_NAME);

    // Level/Facility info
    const levelId = getAttributeValue(attributes, floorField);
    const levelData = levels.getLevelData(levelId);
    const levelName = levelData.levelName;
    const facilityName = levelData.facilityName;
    const template = i18n.more.bookWorkspace.levelDescription;
    const description = stringFormatter(template, {
      level: levelName,
      facility: facilityName
    });

    // Format a date string from the start and end times
    const mStartTime = moment(startTime);
    const mEndTime = moment(endTime);
    const isAllDay = getAttributeValue(attributes, FieldNames.ALL_DAY);
    const formattedDate = workspaceReservationUtil.formatDate(mStartTime, mEndTime, isAllDay);

    // Check state to see if cancel button is needed
    const state = getAttributeValue(attributes, FieldNames.STATE);
    const hideCheckIn = checkInOutUtil.hideCheckInButton(attributes);

    let label, icon, cls, title;
    if (showButton && showButton === "checkIn") {
      label = i18n.more.bookWorkspace.checkInOut.checkIn.caption;
      icon = (<SignInIcon size={20}/>);
      cls = CSS.buttonCheckIn;
      title = label;
    } else {
      label = i18n.more.bookWorkspace.checkInOut.checkOut.caption;
      icon = (<SignOutIcon size={20}/>);
      cls = CSS.buttonCheckOut;
      title = label;
    }

    const addToCalendarButton = (
      <button
        className={CSS.addToCalendar}
        data-id={"calendar"}
        onClick={this._togglePopover}
      >
        {Icons.calendarPlus()}
        {i18n.general.add}
      </button>
    );

    const editButton = (
      <button
        className={CSS.edit}
        data-id={"cancel"}
        onClick={this._scheduleClicked}
      >
        <PencilIcon size={20}/>
        {i18n.more.bookWorkspace.checkInOut.rescheduleBooking.caption}
      </button>
    )

    const cancelButton = (
      <button
        className={CSS.cancel}
        data-id={"cancel"}
        onClick={this._cancelClicked}
      >
        <XIcon size={20}/>
        {i18n.general.cancel}
      </button>
    );

    const reservationsDataset = Context.getInstance().aiim.datasets.reservations;
    const unitsDataset = Context.getInstance().aiim.datasets.units;
    const calendarParams = makeEventInfo(reservationsDataset, reservation, unitsDataset, unit);

    return (
      <li className={CSS.bookingCard}>
        <div className="i-book-card-container">
          <div
            id={this._componentId}
            className={CSS.descriptionContent}
            ref={this._itemRef}
            role="button"
            tabIndex="0"
            onClick={this._bookingCardClicked}
            onKeyDown={this._onKeyDown}
          >
            <h3 className={CSS.bookingInfoLine}>
              <ClockIcon />
              {formattedDate}
            </h3>
            <h4 className={CSS.bookingInfoLine}>
              <PinIcon />
              {unitName}
            </h4>
            <h4 className={CSS.locationDescription} style={{paddingLeft: "1.3rem", paddingRight: "1.4rem", marginBottom: "0.5rem"}}>{description}</h4>
          </div>
          <div className={CSS.actionGroup}>
            {!hideCheckIn ? (
              <div>
                <Button
                  className={cls}
                  icon={icon}
                  title={title}
                  iconPosition="before"
                  onClick={this.handleToggle}>
                  <span>{label}</span>
                </Button>
              </div>
            ): (
              <div style={{ width: 'calc(100%/3)' }}></div>
            )}
            {/* <div className={CSS.actionSubGroup}> */}
              <CalendarSelector
                onRequestClose={this._togglePopover}
                open={popoverOpen}
                targetEl={addToCalendarButton}
                params={calendarParams}
                _updateICSfile={this.props.updateICSfile}
              />
              {editButton}
              {state === CHECKED_IN ? null : cancelButton}
            {/* </div> */}
          </div>
        </div>
      </li>
    );
  }

  _rescheduleBooking = async(when, isOngoingBooking)=> {
    const unit = this.props && this.props.data && this.props.data.unit;
    const unitAttr = unit && unit.attributes;
    const unitFeature = this.state.unitFeature;
    const resFeature = this.props.data && this.props.data.booking;

    const details = {
      when: when,
      isOngoingBooking: isOngoingBooking,
      unitAttr: unitAttr,
      unitFeature: unitFeature,
      checkAvailability: this.checkAvailability,
      selfBooking: true,
      bookingType: "hotel",
      originalReservation: { attributes: resFeature && resFeature.attributes, booking: null },
    }
    workspaceReservationUtil.rescheduleBooking(details);
  }

  _scheduleClicked =async()=> {
    const { data } = this.props;
    const resFeature = data && data.booking;
    const details = {
      reservation: resFeature,
      rescheduleBooking: this._rescheduleBooking,
      operation: "updateBookingTime",
      bookingType: "hotel"
    }
    workspaceReservationUtil.showScheduleViewEsri(details);
  }
}

const mapStateToProps = (state) => {
  return {
    rdxDateOption: Rdx.getValue(state,Rdx.Keys.BOOK_DATEFILTER_OPTION),
    rdxDateSelected: Rdx.getValue(state,Rdx.Keys.BOOK_DATEFILTER_DATESELECTED)
  }
}

export default connect(mapStateToProps)(MyBookings);
